import { render, staticRenderFns } from "./StatsCarousel.vue?vue&type=template&id=6fe6cde7"
import script from "./StatsCarousel.vue?vue&type=script&lang=js"
export * from "./StatsCarousel.vue?vue&type=script&lang=js"
import style0 from "./StatsCarousel.vue?vue&type=style&index=0&id=6fe6cde7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports